// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-RegexpInput-RegexpInput-module__box--fU9uW {
  display: flex;
  flex-direction: column;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-RegexpInput-RegexpInput-module__suggestBox--fXsyA {
  display: flex;
  flex-direction: row;
  gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ManagementPage/Obj2Tab/forms/AttrForm2/MetaInfo/RegexpInput/RegexpInput.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n}\n.suggestBox {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-RegexpInput-RegexpInput-module__box--fU9uW`,
	"suggestBox": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-RegexpInput-RegexpInput-module__suggestBox--fXsyA`
};
export default ___CSS_LOADER_EXPORT___;
